import { Localizer } from '../utils/localize.js';

export const enGb = {
    code: 'en-gb',
    name: 'English',
    dir: 'ltr',

    welcome: 'Welcome',
    'wj.file.upload.button': 'Browse files',
    'wj.file.upload.uploaded': 'Uploaded: ',
    'wj.file.upload.from': 'from',
    'wj.file.upload.error.invalid.type': 'This file type is not supported. Allowed formats: {acceptedTypes}.',
    'wj.file.upload.error.file.too.large': 'The file is too large. Maximum size is {maxFileSize} MB.',
    'wj.file.upload.error.max.files': 'You can upload up to {maxFiles} files.',
    'wj.file.upload.error.generic': 'The file could not be uploaded.',
    'wj.stepper.button.next': 'Next',
    'wj.stepper.button.finish': 'Finish',
    'wj.stepper.button.previous': 'Previous',
    'wj.stepper.step': 'Step',
    'wj.pagination.of': 'of',
    'wj.pagination.first': 'First page',
    'wj.pagination.prev': 'Previous',
    'wj.pagination.next': 'Next',
    'wj.pagination.last': 'Last page',
    'wj.select.empty': 'No data',
};

Localizer.registerTranslation(enGb);
